<template>
  <BaseIndex
    ref="baseIndex"
    :modelNameSingular="modelNameSingular"
    :modelNamePlural="modelNamePlural"
    :pageLoading="pageLoading"
    :loading="loading"
    :table-headers="tableHeaders"
    :table-items="bankAccounts"
    :maskFields="maskFields"
    :itemClass="itemClasses"
    @options-change="optionsChange"
    :serverItemsLength="totalItems"
    :loadOptions="options"
    :enableCustomFilters="true"
    :containTopToolbar="false"
    :typeOperators="typeOperators"
    :serverFields="serverFields"
    @filter-confirm-action="applyFilters"
  >

    <template slot="new" v-if="$can('create', $router.currentRoute.name)">
      <New
        @entry-created="entryCreated"
        :modelNameSingular="modelNameSingular"
      />
    </template>

    <template slot="show" slot-scope="{ item }" v-if="$can('read', $router.currentRoute.name)">
      <Edit
        :entry="item"
        :readOnly="true"
        :modelNameSingular="modelNameSingular"
      />
    </template>

    <template slot="edit" slot-scope="{ item }" v-if="$can('update', $router.currentRoute.name)">
      <Edit
        :entry="item"
        @entry-updated="entryUpdated"
        :modelNameSingular="modelNameSingular"
        :isEdit="true"
      />
    </template>

    <template slot="delete" slot-scope="{ item }" v-if="$can('delete', $router.currentRoute.name)">
      <Delete
        :entry="item"
        @entry-destroyed="entryDeleted"
        :modelNameSingular="modelNameSingular"
      />
    </template>

    <template slot="action1" slot-scope="{ item }">
      <v-tooltip top>
        <template v-slot:activator="{ on: tooltip }">
          <v-btn
            text
            title="Operações Bancárias"
            icon
            link
            :to= "'/app/bank_account_operations/' + item.id"
            v-on="{ ...tooltip }"
          >
            <v-badge
              :content="item.bankAccountOperationsCount"
              :value="item.bankAccountOperationsCount"
              color="green"
              overlap
              offset-y="10"
            >
              <v-icon>mdi-bank-transfer</v-icon>
            </v-badge>
          </v-btn>
        </template>
        <span>Operações Bancárias</span>
      </v-tooltip>
    </template>

    <template slot="action2" slot-scope="{ item }">
      <BankStatement
        :entry="item"
      />
    </template>

    <!-- <template slot="action2" slot-scope="{ item }">
      <v-tooltip top>
        <template v-slot:activator="{ on: tooltip }">
          <v-btn
            text
            title="Extrato Bancário"
            icon
            link
            :to= "'/app/cash_book/' + item.id"
            v-on="{ ...tooltip }"
          >
            <v-icon>mdi-chart-bar</v-icon>
          </v-btn>
        </template>
        <span>Extrato Bancário</span>
      </v-tooltip>
    </template> -->

    <template v-if="!item.acceptsNegativeValue && item.hasNegativeBankAccountOperationsHistory" slot="action3" slot-scope="{ item }">
      <v-tooltip top color="warning">
        <template v-slot:activator="{ on }">
          <v-icon
            color="warning"
            dark
            v-on="on"
            class="mx-1">
            {{'mdi-alert'}}
          </v-icon>
        </template>
        <span>Este tipo de conta não aceita saldo negativo, mas de acordo com o histórico de operações bancárias, há momentos em que o saldo fica negativo.</span>
      </v-tooltip>
    </template>

    <template slot="tableFooter">
      <tr class="d-none d-md-table-row">
        <td colspan="5" class="text-right"><strong class="title mx-3">Saldo Total:</strong></td>
        <td colspan="2" class="text-left title"><strong>{{ this.bankAccountTotalBalance | formatCurrency }}</strong></td>
      </tr>

       <!-- for mobile only -->
      <tr class="d-table-row d-md-none v-data-table__mobile-table-row">
        <td class="v-data-table__mobile-row">
          <div class="v-data-table__mobile-row__header">Saldo Total:</div>
          <div class="v-data-table__mobile-row__cell"><strong>{{ this.bankAccountTotalBalance | formatCurrency }}</strong></div>
        </td>
      </tr>
    </template>

  </BaseIndex>
</template>

<script>
import gql from 'graphql-tag'
import BaseIndex from "@shared_components/base_index.vue";
import New from "./new.vue";
import Edit from "./edit.vue";
import Delete from "./delete.vue";
import BankStatement from "./bank_statement.vue";

export default {
  data() {
    return {
      bankAccounts: [],
      loading: true,
      pageLoading: false,
      totalItems: 0,
      tableHeaders: [
        //trocar id para code depois que vier a coluna
        // { text: "Código", align: "left", sortable: true, value: "id" },
        { text: "Nome da Conta", align: "left", sortable: true, value: "name" },
        { text: "Banco", align: "left", sortable: true, value: "bank.name" },
        { text: "Agência", align: "left", sortable: true, value: "agencyNumber" },
        { text: "Número", align: "left", sortable: true, value: "accountNumber" },
        { text: "Tipo de Conta", align: "left", sortable: true, value: "bankAccountType.name" },
        { text: "Saldo Atual", align: "left", sortable: false, value: "currentBalance" },
        { text: "Ativo", align: "left", sortable: true, value: "enabled" },
        { text: "Ações", align: "left", sortable: false, value: "action" }
      ],
      maskFields: [
        { field: 'currentBalance', mask: 'currency' },
        {field: "enabled", mask: "nice_boolean"},
      ],
      bankAccountTotalBalance: null,
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ["name"],
        sortDesc: [true],
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: true
      },
      filters: [],
      typeOperators: [],
      serverFields: [],
    };
  },
  props: {
    modelNameSingular: {
      type: String,
      default: "Conta Bancária"
    },
    modelNamePlural: {
      type: String,
      default: "Contas Bancárias"
    },
  },
  components: {
    BaseIndex: BaseIndex,
    New: New,
    Edit: Edit,
    Delete: Delete,
    BankStatement: BankStatement
  },
  created() {
    // this.loadServerEntries();
  },
  methods: {
    applyFilters: function(filtersList) {
      this.filters = filtersList;
      this.options.page = 1;
      this.loadServerEntries();
    },
    loadServerEntries: function() {
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_ALL_BANK_ACCOUNTS,
           variables: {
            input: {
              limit: this.options.itemsPerPage,
              offset: (this.options.page - 1) * this.options.itemsPerPage,
              sortBy: this.options.sortBy,
              sortDesc: this.options.sortDesc,
              fields: this.tableHeaders.map(val => val.value),
              filters: this.filters
            }
          },
          fetchPolicy: "no-cache"
        })
        .then(response => {
          this.bankAccounts = response.data.accountContext.bankAccountsIndex.bankAccounts;

          this.totalItems = response.data.accountContext.bankAccountsIndex.count;
          this.typeOperators = response.data.accountContext.bankAccountsIndex.typeOperators;
          this.serverFields = response.data.accountContext.bankAccountsIndex.serverFields;

          this.bankAccountTotalBalance = 0;
          for (var bankAccount in this.bankAccounts) {
            this.bankAccountTotalBalance += this.bankAccounts[bankAccount].currentBalance;
          }
          this.bankAccountTotalBalance = _.round(this.bankAccountTotalBalance, 2);
          // console.log("All bankAccounts", this.bankAccounts);
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
    },
    entryUpdated: function(){
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationUpdateMessage();
    },
    entryCreated: function(){
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationCreateMessage();
    },
    entryDeleted: function(){
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationDeleteMessage();
    },
    itemClasses: function(item) {
      if (item.currentBalance < 0) {
        return "negative_balance";
      }
    },
    optionsChange: function(opts) {
      this.options = opts;
      this.loadServerEntries();
    }
  }
};

const LOAD_ALL_BANK_ACCOUNTS = gql `
query($input: IndexInputObject!) {
    accountContext {
      bankAccountsIndex(input: $input) {
        count
        bankAccounts {
          id
          name
          currentBalance
          accountNumber
          agencyNumber
          enabled
          bankAccountType {
            id
            name
          }
          bank {
            id
            name
            nameWithCode
          }
          bankAccountOperationsCount
          acceptsNegativeValue
          hasNegativeBankAccountOperationsHistory
          canBeDeleted
          undeletabilityReasons
        }
        typeOperators
        serverFields
      }
    }
  }
`;

</script>

<style scoped>
  ::v-deep .negative_balance {
    color: red;
  }
</style>
